"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _getEarlyRequesterResultPromise = _interopRequireDefault(require("../getEarlyRequesterResultPromise"));

var BLOG_FETCH_LIMIT = 300;
var BLOG_URI = 'blog-settings/v1/blogs';

var PORTAL_ID = _hubspot.default.get();

var BlogsAPI =
/*#__PURE__*/
function () {
  function BlogsAPI() {
    (0, _classCallCheck2.default)(this, BlogsAPI);
  }

  (0, _createClass2.default)(BlogsAPI, null, [{
    key: "getBlogs",
    value: function getBlogs() {
      return (0, _getEarlyRequesterResultPromise.default)('blogs') || _apiClient.default.get(BLOG_URI, {
        query: {
          limit: BLOG_FETCH_LIMIT
        }
      });
    }
  }, {
    key: "createBlog",
    value: function createBlog(blog) {
      return _apiClient.default.post(BLOG_URI, {
        query: {
          portalId: PORTAL_ID,
          casing: 'snake'
        },
        data: blog
      });
    }
  }, {
    key: "updateBlog",
    value: function updateBlog(blog) {
      return _apiClient.default.put(BLOG_URI + "/" + blog.id, {
        data: blog
      });
    }
  }, {
    key: "deleteBlog",
    value: function deleteBlog(_ref) {
      var id = _ref.id,
          options = _ref.options;
      return _apiClient.default.post(BLOG_URI + "/" + id + "/delete-with-options", {
        data: options,
        timeout: 10000
      });
    }
  }, {
    key: "createNotificationEmails",
    value: function createNotificationEmails(_ref2) {
      var id = _ref2.id;
      return _apiClient.default.post(BLOG_URI + "/" + id + "/setup-notification-emails");
    }
  }]);
  return BlogsAPI;
}();

exports.default = BlogsAPI;
module.exports = exports.default;